<template>
  <div class="all-box">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span>邀请好友送积分</span>
      </div>
      <el-input placeholder="请输入" v-model="form.invite_friend_five_score">
        <template slot="append">分</template>
      </el-input>
      <div class="min-text">
        提示:邀请新用户赠送积分，邀请相同用户不会获得积分
      </div>
      <div class="box-bth">
        <el-button @click="setUserSourceConfig" type="success">更新</el-button>
      </div>
    </el-card>
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span>新关注公众号送积分</span>
      </div>
      <el-input placeholder="请输入" v-model="form.first_focus_give_score">
        <template slot="append">分</template>
      </el-input>
      <div class="min-text">提示:关注公众号获得积分，仅第一次关注有效</div>
      <div class="box-bth">
        <el-button @click="setUserSourceConfig" type="success">更新</el-button>
      </div>
    </el-card>
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span>佣金获得比例</span>
      </div>
      <el-input placeholder="请输入" v-model="form.commission_rate">
        <template slot="append">%</template>
      </el-input>
      <div class="min-text">
        提示:被邀请人充值后邀请人获得充值金额的百分比佣金
      </div>
      <div class="box-bth">
        <el-button @click="setUserSourceConfig" type="success">更新</el-button>
      </div>
    </el-card>
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span>积分兑换查询金额比例</span>
      </div>
      <div class="box-bard-content">
        <div class="left-text">1元 =</div>
        <div class="right-text">
          <el-input placeholder="请输入" v-model="form.redeem_money">
            <template slot="append">分</template>
          </el-input>
        </div>
      </div>
      <div class="min-text">提示:获得的积分兑换查询金额</div>
      <div class="box-bth">
        <el-button @click="setUserSourceConfig" type="success">更新</el-button>
      </div>
    </el-card>
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span>积分兑换报价单积分比例</span>
      </div>
      <div class="box-bard-content">
        <div class="left-text">报价单100积分 = 保修查查</div>
        <div class="right-text">
          <el-input
            style="width: 65%"
            placeholder="请输入"
            v-model="form.redeem_bjd_score"
          >
            <template slot="append">积分</template>
          </el-input>
        </div>
      </div>
      <div class="min-text">提示:获得的积分同步报价单的积分的计算方式</div>
      <div class="box-bth">
        <el-button @click="setUserSourceConfig" type="success">更新</el-button>
      </div>
    </el-card>
  </div>
</template>

<script>
import {
  getUserSourceConfig,
  setUserSourceConfig
} from "@/request/api/setting";

export default {
  data() {
    return {
      form: {
        invite_friend_five_score: 0,
        first_focus_give_score: 0,
        commission_rate: 0,
        redeem_bjd_score: 0,
        redeem_money: 0
      }
    };
  },
  created() {
    this.getUserSourceConfig();
  },
  methods: {
    getUserSourceConfig() {
      getUserSourceConfig().then(res => {
        this.form = res;
      });
    },
    setUserSourceConfig() {
      setUserSourceConfig(this.form).then(() => {
        this.$message({
          message: "成功",
          type: "success"
        });
      });
    }
  }
};
</script>
<style scoped>
.all-box {
  display: flex;
  flex-wrap: wrap;
}
.box-card {
  width: 40%;
  margin-right: 40px;
  box-shadow: none;
  margin-top: 20px;
}
.min-text {
  font-size: 14px;
  margin: 10px 0;
}
.box-bth {
  display: flex;
  justify-content: flex-end;
}
.box-bard-content {
  display: flex;
  align-items: center;
}
.right-text {
  flex: 1;
  margin-left: 10px;
}
</style>
